module.exports = __webpack_public_path__ + "static/media/talking-by-door.7339f70e.png";